import React, { useEffect, createElement } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { BeforeAfterSection } from './components/BeforeAfterSection';
import { BonusSection } from './components/BonusSection';
import { MidPageCTA } from './components/MidPageCTA';
import { ValueStackSection } from './components/ValueStackSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PurchaseSection } from './components/PurchaseSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  useEffect(() => {
    // Meta Pixel - Fresh Install
    try {
      const w = window as any;
      if (w.fbq) return;
      const n: any = w.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!w._fbq) w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      w.fbq('init', '790333870788238');
      w.fbq('track', 'PageView');
    } catch (e) {
      console.warn('Meta Pixel failed to initialize:', e);
    }
  }, []);
  return <div className="min-h-screen font-sans" data-id="element-0" data-mp="38l8eviz7tido">
      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-1" data-mp="3dkl0k0ecojeo">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=790333870788238&ev=PageView&noscript=1" alt="" data-id="element-2" data-mp="3dl4ktnrh3jvv" />
      </noscript>

      <UrgencyBar data-id="element-3" data-mp="swqcvjfihlyi" />

      <main data-id="element-4" data-mp="36huv2f1ajz4">
        <HeroSection data-id="element-5" data-mp="35yq6nee9s31" />
        <PainSection data-id="element-6" data-mp="35gmj5pekbl3" />
        <ProblemSection data-id="element-7" data-mp="34x4zq3nzp7l" />
        <SolutionSection data-id="element-8" data-mp="38b7cycbvyf1" />
        <BeforeAfterSection data-id="element-9" data-mp="3udaw269tuj3n" />
        <BonusSection data-id="element-10" data-mp="3ubzumd3utnfp" />
        <MidPageCTA data-id="element-11" data-mp="3ucj8niqdvrog" />
        <ValueStackSection data-id="element-12" data-mp="d4nwrk0ubq3z" />
        <TestimonialsSection data-id="element-13" data-mp="d4xobc1ja5bs" />
        <PurchaseSection data-id="element-14" data-mp="d45tw4joadn3" />

        <section className="py-6 px-4 bg-white" data-id="element-15" data-mp="d2bjhk6123x9">
          <div className="max-w-3xl mx-auto text-center" data-id="element-16" data-mp="86mgt7ypo6wq">
            <p className="text-lg md:text-xl font-semibold text-gray-600 italic" data-id="element-17" data-mp="3gle9ehqxh1en">
              Creado por Aula Mater, proyecto educativo enfocado en facilitar el
              trabajo docente mediante recursos listos para imprimir y usar en
              el aula.
            </p>
          </div>
        </section>

        <GuaranteeSection data-id="element-18" data-mp="3lkr2hk8e74po" />
      </main>

      <footer className="bg-gray-900 text-gray-400 text-center py-8 px-4" data-id="element-19" data-mp="3liwjwcklfoor">
        <div className="max-w-3xl mx-auto space-y-3" data-id="element-20" data-mp="2xu3mscs8jask">
          <p className="text-sm text-gray-300" data-id="element-21" data-mp="2xsk46fj3wnnm">
            © 2026 Aula Mater. Todos los derechos reservados.
          </p>
          <p className="text-xs leading-relaxed" data-id="element-22" data-mp="18e171cv5hagc">
            Este sitio no es parte del sitio web de Facebook ni de Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca comercial de FACEBOOK, Inc.
          </p>
        </div>
      </footer>

      <SocialProofPopup data-id="element-23" data-mp="13dwutz19z1vx" />
    </div>;
}